
	/**
	 * @description
	 *  Modelo de un producto en una nota de CyR o NC, sobre un pedido.
	 *
	 * @see gigot-backend/Models/Orders/OrderEvent.cs
	 */

export class OrderEventProducts {

	public campaignProductReturnId: number;
	public id: number;
	public orderEventId: number;
	public quantity: number;

	/**
	 * @description
	 *	Construye un producto de una nota con una semántica vacía. Nótese que
	 *	no es lo mismo que construir un producto con valores por defecto. Las
	 *	reglas generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un producto en una nota de CyR/NC vacío.
	 */
	public static empty(): OrderEventProducts {
		const orderEventProducts: OrderEventProducts = new OrderEventProducts();
		orderEventProducts.campaignProductReturnId = undefined;
		orderEventProducts.id = undefined;
		orderEventProducts.orderEventId = undefined;
		orderEventProducts.quantity = undefined;
		return orderEventProducts;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderEventProducts
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderEventProducts: OrderEventProducts): OrderEventProducts {
		if (!anemicOrderEventProducts) return undefined;
		const orderEventProducts: OrderEventProducts = OrderEventProducts.empty();
		orderEventProducts.campaignProductReturnId = anemicOrderEventProducts.campaignProductReturnId;
		orderEventProducts.id = anemicOrderEventProducts.id;
		orderEventProducts.orderEventId = anemicOrderEventProducts.orderEventId;
		orderEventProducts.quantity = anemicOrderEventProducts.quantity;
		return orderEventProducts;
	}
}
